import { colors } from '@atlaskit/theme';
import { getTokenValue, token } from '@atlaskit/tokens';
import type { Point } from '../../../common/types';
import {
	X_AXIS_TYPE,
	Y_AXIS_TYPE,
	AXIS_COLOR,
	AXIS_LABEL_COLOR,
	TOOL_TIP_TRIGGER,
} from './constants';

export const getXAxisConfiguration = (axisLabelsData: string[]) =>
	({
		type: X_AXIS_TYPE,
		boundaryGap: false,
		axisLine: {
			lineStyle: {
				color: AXIS_COLOR,
			},
		},
		axisLabel: {
			color: AXIS_LABEL_COLOR,
		},
		data: axisLabelsData,
	}) as const;

export type MinMax = {
	min?: number;
	max?: number;
};

type YConfigParam = {
	yAxisFormatter: (arg1: string) => string;
	minMaxConfig: MinMax;
};

export const getYAxisConfiguration = ({ yAxisFormatter, minMaxConfig }: YConfigParam) => {
	const config = {
		type: Y_AXIS_TYPE,
		splitLine: {
			show: true,
			lineStyle: {
				color: AXIS_COLOR,
			},
		},
		axisLabel: {
			color: AXIS_LABEL_COLOR,
			showMaxLabel: true,
			formatter: yAxisFormatter,
		},
		minInterval: 1,
		boundaryGap: ['0', '5%'],
		...minMaxConfig,
	};

	return config;
};

export const getGridConfiguration = () =>
	({
		show: true,
		borderColor: AXIS_COLOR,
		left: '5%',
		right: '3%',
		bottom: '15%',
	}) as const;

export const getTooltipConfiguration = (formatter: (points: Point[]) => string) =>
	({
		backgroundColor: token('color.background.neutral.bold', colors.N900),
		trigger: TOOL_TIP_TRIGGER,
		triggerOn: 'none',
		transitionDuration: 0,
		textStyle: {
			color: token('color.text.inverse', colors.N0),
		},
		extraCssText: `box-shadow: ${token('elevation.shadow.raised', '0 0 8px rgba(0, 0, 0, 0.3)')}`,
		axisPointer: {
			type: 'shadow',
			shadowStyle: {
				color: getTokenValue('color.background.neutral.subtle.hovered', colors.N10A),
			},
		},
		formatter,
	}) as const;
